import StageCard from "../../ProgressStep/StageCard";
import { Button, Tooltip } from "antd";
import React from "react";
import styles from "./style.module.scss";
import AddIcon from "assets/icons/AddIcon";

interface AddClassCardProps {
  onClick: () => void;
}

export default function AddClassCard({ onClick }: AddClassCardProps) {
  return (
    <StageCard
      content={
        <div>
          <div className={styles.titleContainer}>
            <div className={styles.title}>Choose Labels</div>
            <div className={styles.subTitle}>
              Define the Initial Labels for Label Propagation
            </div>
          </div>
          <Tooltip
            title="Choose the labels for Label Propagation"
            mouseEnterDelay={0.6}
          >
            <Button
              className={styles.addClassButton}
              onClick={onClick}
              aria-label="Choose labels"
            >
              <AddIcon />
            </Button>
          </Tooltip>
        </div>
      }
    />
  );
}
